// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#header {
  background-color: var(--sebrae-white);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
}
#header nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
#header nav .btn {
  position: relative;
  z-index: 3;
}
#header nav .btn.active {
  background: var(--sebrae-white);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
#header nav .list-menu {
  position: fixed;
  top: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  left: -100%;
  transition: 0.3s;
}
#header nav .list-menu.open {
  background: rgba(0, 0, 0, 0.3);
  left: 0;
}
#header nav .list-menu .content {
  background-color: var(--sebrae-blue);
  width: 70%;
  height: 100%;
  padding: 15px 15px 15px 68px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
#header nav .list-menu .content .close {
  position: absolute;
  width: 30%;
  height: 100%;
  top: 0;
  right: 0;
}
#header nav .list-menu .content .title-menu a {
  text-decoration: none;
}
#header nav .list-menu .content .title-menu h3 {
  color: var(--sebrae-white);
  font-size: 19px;
  line-height: normal;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
#header nav .list-menu .content ul {
  padding-left: 12px;
  padding-top: 23px;
}
#header nav .list-menu .content ul li {
  position: relative;
  height: 40px;
  display: flex;
  align-items: center;
}
#header nav .list-menu .content ul li.active:before {
  content: "";
  width: 4px;
  height: 100%;
  position: absolute;
  left: -11px;
  top: 0;
  background-color: var(--sebrae-white);
}
#header nav .list-menu .content ul li.active a {
  font-weight: 400;
}
#header nav .list-menu .content ul li a {
  text-decoration: none;
  color: var(--sebrae-white);
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 23.3px;
}
#header nav .list-menu .content ul li h4,
#header nav .list-menu .content ul li a,
#header nav .list-menu .content ul li button,
#header nav .list-menu .content ul li div {
  font-size: 16px;
  color: var(--sebrae-white);
  font-weight: 300;
}
#header nav .list-menu .content ul li h4 span,
#header nav .list-menu .content ul li a span,
#header nav .list-menu .content ul li button span,
#header nav .list-menu .content ul li div span {
  display: block;
}
#header nav .list-menu .content ul li h4 span.mid,
#header nav .list-menu .content ul li a span.mid,
#header nav .list-menu .content ul li button span.mid,
#header nav .list-menu .content ul li div span.mid {
  font-size: 12px;
  font-weight: 300;
}
#header nav .list-menu .content ul li h4 svg,
#header nav .list-menu .content ul li a svg,
#header nav .list-menu .content ul li button svg,
#header nav .list-menu .content ul li div svg {
  display: none;
}
#header nav .list-menu .content .profile-menu {
  position: relative;
}
#header nav .list-menu .content .profile-menu .icon-profile {
  background-color: var(--sebrae-white);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: -45px;
  top: 0;
}
#header nav .list-menu .content .profile-menu ul {
  padding-top: 0;
}
#header nav .list-menu .content .profile-menu ul li a {
  color: var(--sebrae-white);
  font-weight: 300;
}
#header .logo {
  height: 31px;
  width: 130px;
  object-fit: contain;
}
#header .logo.desktop {
  display: none;
}
@media (min-width: 560px) {
  #header {
    width: 70px;
  }
  #header .svg-color svg, #header nav .list-menu .content ul li:hover svg, #header nav .list-menu .content ul li.active svg {
    transition: 0.3s;
  }
  #header .svg-color svg path, #header nav .list-menu .content ul li:hover svg path, #header nav .list-menu .content ul li.active svg path {
    fill: var(--sebrae-blue);
  }
  #header nav {
    justify-content: left;
    align-items: start;
    flex-direction: column;
    gap: 20px;
    padding-top: 30px;
  }
  #header nav .profile,
  #header nav .logo {
    position: relative;
    z-index: 2;
  }
  #header nav .title-menu,
  #header nav .btn-menu {
    display: none;
  }
  #header nav .list-menu {
    width: 70px;
    left: 0;
  }
  #header nav .list-menu .content {
    width: 70px;
    background: linear-gradient(45deg, #9285f9 0%, #cd5be8 100%);
    padding: 110px 0 0;
  }
  #header nav .list-menu .content .close {
    display: none;
  }
  #header nav .list-menu .content ul {
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  #header nav .list-menu .content ul li {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    transition: 0.3s;
    margin: 15px 0;
  }
  #header nav .list-menu .content ul li.disabled:not(.active) {
    opacity: 0;
    display: none;
  }
  #header nav .list-menu .content ul li a,
  #header nav .list-menu .content ul li div {
    cursor: pointer;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  #header nav .list-menu .content ul li.active {
    background-color: white;
  }
  #header nav .list-menu .content ul li.active:before {
    content: none;
  }
  #header nav .list-menu .content ul li.active h4 {
    font-weight: 400;
  }
  #header nav .list-menu .content ul li:hover {
    background-color: white;
  }
  #header nav .list-menu .content ul li a,
  #header nav .list-menu .content ul li div {
    display: flex;
  }
  #header nav .list-menu .content ul li a span,
  #header nav .list-menu .content ul li div span {
    display: none;
  }
  #header nav .list-menu .content ul li a svg,
  #header nav .list-menu .content ul li div svg {
    display: block;
  }
  #header nav .list-menu .content .profile-menu .icon-profile {
    position: relative;
    left: 4px;
    margin: 10px 10px 15px;
    cursor: pointer;
  }
  #header nav .list-menu .content .profile-menu ul {
    background-color: #ffffff;
    position: absolute;
    left: 74px;
    bottom: -300px;
    width: 300px;
    border-radius: 8px;
    box-shadow: 0 2px 28px 0 rgba(20, 46, 82, 0.2);
    padding: 15px 0;
    transition: 0.4s;
  }
  #header nav .list-menu .content .profile-menu ul.profile-menu-open {
    bottom: 15px;
  }
  #header nav .list-menu .content .profile-menu ul:before {
    content: "";
    position: absolute;
    bottom: 0;
    left: -32px;
    right: auto;
    border-bottom: 20px solid transparent;
    border-top: 20px solid transparent;
    border-right: 20px solid #ffffff;
    border-left: 20px solid transparent;
  }
  #header nav .list-menu .content .profile-menu ul li {
    width: 100%;
    justify-content: start;
    border-radius: 0;
    margin: 0;
    height: 40px;
    padding: 0 20px;
    transition: 0.3s;
  }
  #header nav .list-menu .content .profile-menu ul li:hover {
    background: #f3f3f3;
  }
  #header nav .list-menu .content .profile-menu ul li:first-child {
    margin-bottom: 10px;
  }
  #header nav .list-menu .content .profile-menu ul li:first-child:hover {
    background-color: transparent;
  }
  #header nav .list-menu .content .profile-menu ul li a {
    display: block;
    width: 100%;
    height: 100%;
    padding: 8px 0;
    color: var(--sebrae-black);
  }
  #header nav .list-menu .content .profile-menu ul li h4,
  #header nav .list-menu .content .profile-menu ul li a {
    display: flex;
    color: var(--sebrae-black);
    flex-direction: column;
    align-items: start;
  }
  #header nav .list-menu .content .profile-menu ul li h4 span,
  #header nav .list-menu .content .profile-menu ul li a span {
    display: block;
  }
  #header nav .list-menu .content .profile-menu ul li h4 img,
  #header nav .list-menu .content .profile-menu ul li a img {
    display: none;
  }
  #header nav .list-menu .content .profile-menu ul li button {
    color: var(--sebrae-black);
    width: 100%;
    height: 100%;
    text-align: left;
  }
  #header .logo {
    width: 100%;
  }
  #header .logo.mobile {
    display: none;
  }
  #header .logo.desktop {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/layout/header/index.scss"],"names":[],"mappings":"AAAA;EACE,qCAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AACJ;AACI;EACE,kBAAA;EACA,UAAA;AACN;AACM;EACE,+BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACR;AAGI;EACE,eAAA;EACA,MAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AADN;AAGM;EACE,8BAAA;EACA,OAAA;AADR;AAIM;EACE,oCAAA;EACA,UAAA;EACA,YAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAFR;AAIQ;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,MAAA;EACA,QAAA;AAFV;AAMU;EACE,qBAAA;AAJZ;AAMU;EACE,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAJZ;AAQQ;EACE,kBAAA;EACA,iBAAA;AANV;AAQU;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AANZ;AASc;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,qCAAA;AAPhB;AAUc;EACE,gBAAA;AARhB;AAYY;EACE,qBAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAVd;AAaY;;;;EAIE,eAAA;EACA,0BAAA;EACA,gBAAA;AAXd;AAac;;;;EACE,cAAA;AARhB;AASgB;;;;EACE,eAAA;EACA,gBAAA;AAJlB;AAQc;;;;EACE,aAAA;AAHhB;AASQ;EACE,kBAAA;AAPV;AASU;EACE,qCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;AAPZ;AASU;EACE,cAAA;AAPZ;AAUc;EACE,0BAAA;EACA,gBAAA;AARhB;AAiBE;EACE,YAAA;EACA,YAAA;EACA,mBAAA;AAfJ;AAiBI;EACE,aAAA;AAfN;AAmBE;EA9KF;IAuLI,WAAA;EAxBF;EAiBI;IACE,gBAAA;EAfN;EAgBM;IACE,wBAAA;EAdR;EAoBE;IACE,qBAAA;IACA,kBAAA;IACA,sBAAA;IACA,SAAA;IACA,iBAAA;EAlBJ;EAoBI;;IAEE,kBAAA;IACA,UAAA;EAlBN;EAqBI;;IAEE,aAAA;EAnBN;EAsBI;IACE,WAAA;IACA,OAAA;EApBN;EAsBM;IACE,WAAA;IACA,4DAAA;IACA,kBAAA;EApBR;EAsBQ;IACE,aAAA;EApBV;EAuBQ;IACE,UAAA;IACA,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,mBAAA;EArBV;EAuBU;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,uBAAA;IACA,mBAAA;IACA,gBAAA;IACA,cAAA;EArBZ;EAwBc;IACE,UAAA;IACA,aAAA;EAtBhB;EA0BY;;IAEE,eAAA;IACA,WAAA;IACA,YAAA;IACA,kBAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;EAxBd;EA2BY;IACE,uBAAA;EAzBd;EA4Bc;IACE,aAAA;EA1BhB;EA6Bc;IACE,gBAAA;EA3BhB;EA+BY;IACE,uBAAA;EA7Bd;EAiCY;;IAEE,aAAA;EA/Bd;EAiCc;;IACE,aAAA;EA9BhB;EAiCc;;IACE,cAAA;EA9BhB;EAqCU;IACE,kBAAA;IACA,SAAA;IACA,sBAAA;IACA,eAAA;EAnCZ;EAqCU;IACE,yBAAA;IACA,kBAAA;IACA,UAAA;IACA,cAAA;IACA,YAAA;IACA,kBAAA;IACA,8CAAA;IACA,eAAA;IACA,gBAAA;EAnCZ;EAqCY;IACE,YAAA;EAnCd;EAsCY;IACE,WAAA;IACA,kBAAA;IACA,SAAA;IACA,WAAA;IACA,WAAA;IACA,qCAAA;IACA,kCAAA;IACA,gCAAA;IACA,mCAAA;EApCd;EAuCY;IACE,WAAA;IACA,sBAAA;IACA,gBAAA;IACA,SAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;EArCd;EAuCc;IACE,mBAAA;EArChB;EAwCc;IACE,mBAAA;EAtChB;EAuCgB;IACE,6BAAA;EArClB;EAyCc;IACE,cAAA;IACA,WAAA;IACA,YAAA;IACA,cAAA;IACA,0BAAA;EAvChB;EA0Cc;;IAEE,aAAA;IACA,0BAAA;IACA,sBAAA;IACA,kBAAA;EAxChB;EA0CgB;;IACE,cAAA;EAvClB;EA0CgB;;IACE,aAAA;EAvClB;EA0Cc;IACE,0BAAA;IACA,WAAA;IACA,YAAA;IACA,gBAAA;EAxChB;EAiDE;IACE,WAAA;EA/CJ;EAiDI;IACE,aAAA;EA/CN;EAiDI;IACE,cAAA;EA/CN;AACF","sourcesContent":["#header {\n  background-color: var(--sebrae-white);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 9;\n  width: 100%;\n  height: 56px;\n  display: flex;\n  align-items: center;\n\n  nav {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    .btn {\n      position: relative;\n      z-index: 3;\n\n      &.active {\n        background: var(--sebrae-white);\n        border-radius: 50%;\n        width: 40px;\n        height: 40px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n    }\n\n    .list-menu {\n      position: fixed;\n      top: 0;\n      z-index: 2;\n      width: 100%;\n      height: 100%;\n      left: -100%;\n      transition: 0.3s;\n\n      &.open {\n        background: rgba(0, 0, 0, 0.3);\n        left: 0;\n      }\n\n      .content {\n        background-color: var(--sebrae-blue);\n        width: 70%;\n        height: 100%;\n        padding: 15px 15px 15px 68px;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n\n        .close {\n          position: absolute;\n          width: 30%;\n          height: 100%;\n          top: 0;\n          right: 0;\n        }\n\n        .title-menu {\n          a {\n            text-decoration: none;\n          }\n          h3 {\n            color: var(--sebrae-white);\n            font-size: 19px;\n            line-height: normal;\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n          }\n        }\n\n        ul {\n          padding-left: 12px;\n          padding-top: 23px;\n\n          li {\n            position: relative;\n            height: 40px;\n            display: flex;\n            align-items: center;\n\n            &.active {\n              &:before {\n                content: \"\";\n                width: 4px;\n                height: 100%;\n                position: absolute;\n                left: -11px;\n                top: 0;\n                background-color: var(--sebrae-white);\n              }\n\n              a {\n                font-weight: 400;\n              }\n            }\n\n            a {\n              text-decoration: none;\n              color: var(--sebrae-white);\n              font-size: 16px;\n              font-style: normal;\n              font-weight: 300;\n              line-height: 23.3px;\n            }\n\n            h4,\n            a,\n            button,\n            div {\n              font-size: 16px;\n              color: var(--sebrae-white);\n              font-weight: 300;\n\n              span {\n                display: block;\n                &.mid {\n                  font-size: 12px;\n                  font-weight: 300;\n                }\n              }\n\n              svg {\n                display: none;\n              }\n            }\n          }\n        }\n\n        .profile-menu {\n          position: relative;\n\n          .icon-profile {\n            background-color: var(--sebrae-white);\n            width: 40px;\n            height: 40px;\n            border-radius: 50%;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            position: absolute;\n            left: -45px;\n            top: 0;\n          }\n          ul {\n            padding-top: 0;\n\n            li {\n              a {\n                color: var(--sebrae-white);\n                font-weight: 300;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .logo {\n    height: 31px;\n    width: 130px;\n    object-fit: contain;\n\n    &.desktop {\n      display: none;\n    }\n  }\n\n  @media (min-width: 560px) {\n    .svg-color {\n      svg {\n        transition: 0.3s;\n        path {\n          fill: var(--sebrae-blue);\n        }\n      }\n    }\n    width: 70px;\n\n    nav {\n      justify-content: left;\n      align-items: start;\n      flex-direction: column;\n      gap: 20px;\n      padding-top: 30px;\n\n      .profile,\n      .logo {\n        position: relative;\n        z-index: 2;\n      }\n\n      .title-menu,\n      .btn-menu {\n        display: none;\n      }\n\n      .list-menu {\n        width: 70px;\n        left: 0;\n\n        .content {\n          width: 70px;\n          background: linear-gradient(45deg, #9285f9 0%, #cd5be8 100%);\n          padding: 110px 0 0;\n\n          .close {\n            display: none;\n          }\n\n          ul {\n            padding: 0;\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            align-items: center;\n\n            li {\n              width: 40px;\n              height: 40px;\n              border-radius: 50%;\n              justify-content: center;\n              align-items: center;\n              transition: 0.3s;\n              margin: 15px 0;\n\n              &.disabled {\n                &:not(.active) {\n                  opacity: 0;\n                  display: none;\n                }\n              }\n\n              a,\n              div {\n                cursor: pointer;\n                width: 100%;\n                height: 100%;\n                border-radius: 50%;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n              }\n\n              &.active {\n                background-color: white;\n                @extend .svg-color;\n\n                &:before {\n                  content: none;\n                }\n\n                h4 {\n                  font-weight: 400;\n                }\n              }\n\n              &:hover {\n                background-color: white;\n                @extend .svg-color;\n              }\n\n              a,\n              div {\n                display: flex;\n\n                span {\n                  display: none;\n                }\n\n                svg {\n                  display: block;\n                }\n              }\n            }\n          }\n\n          .profile-menu {\n            .icon-profile {\n              position: relative;\n              left: 4px;\n              margin: 10px 10px 15px;\n              cursor: pointer;\n            }\n            ul {\n              background-color: #ffffff;\n              position: absolute;\n              left: 74px;\n              bottom: -300px;\n              width: 300px;\n              border-radius: 8px;\n              box-shadow: 0 2px 28px 0 rgba(20, 46, 82, 0.2);\n              padding: 15px 0;\n              transition: 0.4s;\n\n              &.profile-menu-open {\n                bottom: 15px;\n              }\n\n              &:before {\n                content: \"\";\n                position: absolute;\n                bottom: 0;\n                left: -32px;\n                right: auto;\n                border-bottom: 20px solid transparent;\n                border-top: 20px solid transparent;\n                border-right: 20px solid #ffffff;\n                border-left: 20px solid transparent;\n              }\n\n              li {\n                width: 100%;\n                justify-content: start;\n                border-radius: 0;\n                margin: 0;\n                height: 40px;\n                padding: 0 20px;\n                transition: 0.3s;\n\n                &:hover {\n                  background: #f3f3f3;\n                }\n\n                &:first-child {\n                  margin-bottom: 10px;\n                  &:hover {\n                    background-color: transparent;\n                  }\n                }\n\n                a {\n                  display: block;\n                  width: 100%;\n                  height: 100%;\n                  padding: 8px 0;\n                  color: var(--sebrae-black);\n                }\n\n                h4,\n                a {\n                  display: flex;\n                  color: var(--sebrae-black);\n                  flex-direction: column;\n                  align-items: start;\n\n                  span {\n                    display: block;\n                  }\n\n                  img {\n                    display: none;\n                  }\n                }\n                button {\n                  color: var(--sebrae-black);\n                  width: 100%;\n                  height: 100%;\n                  text-align: left;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .logo {\n      width: 100%;\n\n      &.mobile {\n        display: none;\n      }\n      &.desktop {\n        display: block;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
